import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSupabase } from '@/hooks/useSupabase';

interface AuthGuardProps {
    children: React.ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
    const { user, loading } = useSupabase();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!loading && !user) {
            // Redirect to auth page, preserving the current location for redirect after login
            navigate('/auth', {
                replace: true,
                state: { from: location }
            });
        }
    }, [user, loading, navigate, location]);

    if (loading) {
        return null;
    }

    // Don't render children if not authenticated
    if (!user) {
        return null;
    }

    return <>{children}</>;
};